var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTwitchLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 2400 2800",
    style: {
      enableBackground: "new 0 0 2400 2800"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n")), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Asset 3") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M500,0L0,500v1800h600v500l500-500h400l900-900V0H500z M2200,1300l-400,400h-400l-350,350v-350H600V200h1600 V1300z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1700,
    y: 550,
    className: "st0",
    width: 200,
    height: 600
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1150,
    y: 550,
    className: "st0",
    width: 200,
    height: 600
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitchLogo);
export default __webpack_public_path__ + "static/media/TwitchLogo.1bceb263d5b7c934e799bb5de54d27b2.svg";
export { ForwardRef as ReactComponent };